import React, { useState } from 'react';
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";
import backgroundImage from '../../assets/img/aquine.jpg';
import { BASE_URL } from '../utils/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faEye, faEyeSlash, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [email, setemail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();
        const data = { email, password };
        axios.post(`${BASE_URL}/login`, data)
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem('token', response.data.token);
                    const token = localStorage.getItem('token');
                    const decodedToken = jwtDecode(token);
                    const id_tipo_usuario = decodedToken.id_tipo_usuario;
                    
                    // Guardar datos del usuario en sessionStorage
                    sessionStorage.setItem('id_usuario', decodedToken.id_usuario);
                    sessionStorage.setItem('email', decodedToken.email);
                    sessionStorage.setItem('usuario', decodedToken.usuario);
                    sessionStorage.setItem('id_tipo_usuario', decodedToken.id_tipo_usuario);
                    sessionStorage.setItem('nombre', decodedToken.nombre);
                    sessionStorage.setItem('apellido', decodedToken.apellido);
                    
                    console.log('Usuario logueado:', decodedToken);
                    console.log('ID Usuario guardado en sessionStorage:', decodedToken.id_usuario);
                    
                    // Redirigir basado en el tipo de usuario
                    switch (id_tipo_usuario) {
                        case 1:
                            navigate('/dashboard');
                            break;
                        case 2:
                            navigate('/securityHome');
                            break;
                        case 3:
                            navigate('/userHome');
                            break;
                        default:
                            break;
                    }
                } else {
                    alert('Credenciales inválidas');
                }
            })
            .catch(error => {
                console.error(error);
                if (error.response && error.response.data.message === 'Invalid credentials') {
                    alert('Credenciales inválidas');
                } else if (error.response && error.response.data.message === 'User not found') {
                    alert('Usuario no encontrado');
                } else {
                    alert('Error en el servidor. Inténtalo más tarde.');
                }
            });
    };

    return (
        <div className="min-h-screen flex">
            {/* Left side - Image */}
            <div 
                className="hidden lg:flex lg:w-3/5 relative bg-cover bg-center"
                style={{ backgroundImage: `url(${backgroundImage})` }}
            >
                <div className="absolute inset-0 bg-gradient-to-br from-primary-900/70 to-primary-600/70"></div>
                <div className="relative z-10 flex flex-col justify-center items-center text-white p-12">
                    <h1 className="text-5xl font-bold mb-4 animate-fade-in">Bienvenido</h1>
                    <p className="text-xl text-center max-w-md">Sistema de Control de Acceso</p>
                </div>
            </div>

            {/* Right side - Login Form */}
            <div className="flex-1 flex items-center justify-center bg-gray-50 px-4 sm:px-6 lg:px-8">
                <div className="max-w-md w-full space-y-8">
                    <div className="text-center">
                        <div className="mx-auto h-16 w-16 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-primary-700 shadow-lg">
                            <FontAwesomeIcon icon={faLock} className="h-8 w-8 text-white" />
                        </div>
                        <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                            Iniciar Sesión
                        </h2>
                        <p className="mt-2 text-sm text-gray-600">
                            Ingresa tus credenciales para acceder
                        </p>
                    </div>

                    <form className="mt-8 space-y-6" onSubmit={handleLogin}>
                        <div className="space-y-4">
                            {/* Email Input */}
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                    Correo Electrónico
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FontAwesomeIcon icon={faEnvelope} className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        required
                                        value={email}
                                        onChange={(e) => setemail(e.target.value)}
                                        className="input-field pl-10 focus:border-primary-500"
                                        placeholder="correo@ejemplo.com"
                                    />
                                </div>
                            </div>

                            {/* Password Input */}
                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                                    Contraseña
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FontAwesomeIcon icon={faLock} className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <input
                                        id="password"
                                        name="password"
                                        type={showPassword ? 'text' : 'password'}
                                        autoComplete="current-password"
                                        required
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="input-field pl-10 pr-10"
                                        placeholder="••••••••"
                                    />
                                    <button
                                        type="button"
                                        className="absolute inset-y-0 right-0 pr-3 flex items-center"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? (
                                            <FontAwesomeIcon icon={faEyeSlash} className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                                        ) : (
                                            <FontAwesomeIcon icon={faEye} className="h-5 w-5 text-gray-400 hover:text-gray-600" />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Remember Me & Forgot Password */}
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <input
                                    id="remember-me"
                                    name="remember-me"
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                    className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded cursor-pointer"
                                />
                                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-700 cursor-pointer">
                                    Recordarme
                                </label>
                            </div>

                            <div className="text-sm">
                                <Link to="/forgotPassword" className="font-medium text-primary-600 hover:text-primary-500 transition-colors">
                                    ¿Olvidaste tu contraseña?
                                </Link>
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div>
                            <button
                                type="submit"
                                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-semibold rounded-lg text-white gradient-bg hover:shadow-lg transform transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                            >
                                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                                    <FontAwesomeIcon icon={faLock} className="h-5 w-5 text-primary-300 group-hover:text-primary-200" aria-hidden="true" />
                                </span>
                                Ingresar
                            </button>
                        </div>

                        {/* Sign Up Link */}
                        <div className="text-center">
                            <p className="text-sm text-gray-600">
                                ¿No tienes una cuenta?{' '}
                                <a href="#" className="font-medium text-primary-600 hover:text-primary-500 transition-colors">
                                    Regístrate aquí
                                </a>
                            </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;